import styled from 'styled-components';

const isVisible = ({ preTransition }: { preTransition: boolean }) => {
  if (preTransition)
    return {
      opacity: 0,
      'pointer-events': 'none',
    };
  return {
    opacity: 1,
  };
};

const ApplePayButtonContainer = styled.div<{ preTransition: boolean }>`
  ${isVisible};
  margin: 1rem 0 1.25rem 0;
  padding: 1rem 0 1.25rem 0;
  width: 100%;
  transition-delay: 100ms;
  transition: opacity 400ms ease-in-out;

  @media (min-width: 768px) {
    margin: 1rem 0 1.25rem 0;
    padding: 1rem 0 1.25rem 0;
  }

  .apple-pay-button-fixed {
    height: 30pt;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .apple-pay-button-overlay {
    background-color: rgba(60, 64, 67, 0.01);
    opacity: 0.99;
    cursor: pointer;

    :hover {
      opacity: 0.7;
      mix-blend-mode: lighten;
      background-color: rgba(130, 130, 130, 0.7);
    }
  }

  apple-pay-button {
    --apple-pay-button-border-radius: 5px;
    --apple-pay-button-padding: 5px 0px;
    z-index: 0;
  }
`;

export default ApplePayButtonContainer;
